import moment from "moment";

export class utilsServices {

  getBase64Src(content, imageType) {
    imageType = imageType || 'image/gif';
    return `data:${imageType};base64,${content}`;
  }

  /* Determines if selected is between and including from and to
  * @param from moment.
  * @param to moment.
  * @param selected moment. Optional. Selected date that is is evaluated to be
  * between from and to. Default is the current date.
  */
  isBetweenDates(from, to, selected) {
    selected = selected || moment();
    return selected.diff(from) >= 0 && selected.diff(to) <= 0;
  }

  isLater(reference, selected) {
    selected = selected || moment();
    return selected.diff(reference) > 0;
  }

  isSameOrLater(reference, selected) {
    selected = selected || moment();
    return selected.diff(reference) >= 0;
  }
}



// WEBPACK FOOTER //
// ./client/app/services/utils.services.js